import React, { useState, useContext } from "react";
import { GlobalContext } from "../../context/provider";
import getaction from "../../context/action/return_item_company/getaction";
import Return_item_companyeditmodal from "./return_item_companyeditmodal";
import numberbeautify from "../../utils/numberbeautify";
import moment from "moment/moment";

const Return_item_companylist = () => {
    const { initState,recaller, setrecaller, initDispatch, clear } =
    useContext(GlobalContext);

    const [from,setfrom]=useState();
    const [to,setto]=useState();

    const [show,setshow]=useState(false);
    const [error,seterror]=useState(false);
    const [error1,seterror1]=useState(false);

    const [company_return_id,setcompany_return_id]=useState();
    const [company_return_date,setcompany_return_date]=useState();
    const [company_return_note,setcompany_return_note]=useState();
    const [company_id,setcompany_id]=useState();
    const [items,setitems]=useState([]);

    return (
        <div>
            <Return_item_companyeditmodal 
                show={show} 
                setshow={setshow} 
                company_return_id={company_return_id} 
                company_return_date={company_return_date} 
                setcompany_return_date={setcompany_return_date} 
                company_return_note={company_return_note} 
                setcompany_return_note={setcompany_return_note} 
                company_id={company_id} 
                setcompany_id={setcompany_id} 
                items={items} 
                setitems={setitems} 
            />

            {/* Header */}
            <div className="bg-white border border-slate-100 rounded-xl p-6 mt-6 mb-6 shadow-sm">
                <div className="w-full h-20 flex justify-right items-center text-3xl border-b-2 px-5">
                    لیستی کاڵای گەڕاوە
                </div>

            {/* Date Filter Section */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 items-end">
                <div className="w-full mt-3">
                    <label
                        className={
                            error
                            ? "block text-sm font-medium text-red-500 mb-1 text-right"
                            : "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                    >
                        لە بەرواری
                    </label>
                    <input
                        className={
                            error
                            ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                            : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        type="date"
                        value={from}
                        onChange={(val) => setfrom(val.target.value)}
                        onFocus={() => seterror(false)}
                    />
                </div>

                {/* To Date */}
                <div className="w-full">
                    <label
                        className={
                            error1
                            ? "block text-sm font-medium text-red-500 mb-1 text-right"
                            : "block text-sm font-medium text-slate-500 mb-1 text-right"
                        }
                    >
                        بۆ بەرواری
                    </label>
                    <input
                        className={
                            error1
                            ? "w-full h-10 px-3 border border-red-500 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-red-500 focus:border-transparent bg-white"
                            : "w-full h-10 px-3 border border-slate-200 rounded-lg text-sm text-slate-800 placeholder:text-slate-400 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent bg-white"
                        }
                        type="date"
                        value={to}
                        onChange={(val) => setto(val.target.value)}
                        onFocus={() => seterror1(false)}
                    />
                </div>

                {/* Search Button */}
                <div className="w-full">
                    <button
                        className={
                            "h-10 px-6 bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold rounded-lg transition-colors duration-150 w-full"
                        }
                        onClick={() => {
                            if (from == "" || !from) {
                              seterror(true);
                              return false;
                            }
                            if (to == "" || !to) {
                              seterror1(true);
                              return false;
                            }
                            getaction(from,to)(recaller)(setrecaller)(initDispatch)(
                              clear
                            );
                        }}
                    >
                        گەڕان
                    </button>
                </div>
            </div>
            </div>

            {/* Results Table */}
            {initState.return_item_company.length > 0 && (
                <div className="bg-white border border-slate-100 rounded-xl shadow-sm overflow-x-auto mt-6">
        
                    {/* Section Header */}
                    <div className="flex items-center justify-between px-6 py-4 border-b border-slate-100">
                        <h2 className="text-base font-semibold text-slate-800">لیستی پسوڵەی گەڕاوە بۆ کۆمپانیا</h2>
                    </div>

                    {/* Table */}
                    <table className="w-full">
                        <thead>
                        <tr className="bg-slate-50 border-b border-slate-100">
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                کۆمپانیا
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بەروار
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                بڕی گەڕاوە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                نرخی گەڕاوە
                            </th>
                            <th className="px-6 py-3 text-right text-xs font-semibold text-slate-500 uppercase tracking-wide">
                                تێبینی
                            </th>
                        </tr>
                    </thead>
                    <tbody className="divide-y divide-slate-50">
                        {initState.return_item_company.map((lis) => (
                            <tr 
                                key={lis.company_return_id}
                                className="hover:bg-slate-50 transition-colors duration-100 cursor-pointer"
                                onClick={() => {
                                    setcompany_return_id(lis?.company_return_id);
                                    setcompany_return_date(lis?.company_return_date);
                                    setcompany_return_note(lis?.company_return_note);
                                    setcompany_id(lis?.company_id);
                                    setitems(lis?.items);
                                    setshow(true);
                                }}
                            >
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis?.company_name}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {moment(lis?.company_return_date).format('YYYY-MM-DD')}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(lis?.items?.reduce((a,v) => (a=Number(a)+Number(v.item_qty)), 0))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {numberbeautify(lis?.items?.reduce((a,v) => (a=Number(a)+(Number(v.item_qty)*Number(v.item_price))), 0))}
                                </td>
                                <td className="px-6 py-4 text-sm font-medium text-slate-800 text-right">
                                    {lis?.company_return_note}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            )}
        </div>
    );
};

export default Return_item_companylist;